module.exports = __webpack_public_path__ + "img/weya4.2798aeee.png";